<template>
  <section v-editable="blok" feature-title-list :data-style="blok.style || 'default'" :data-theme="blok.theme || 'light'" :style="[styleBackground]" :data-spacing="blok.spacing || 'white'">
    <div class="container">
      <div class="row">
        <div class="section-content">
          <h2 v-if="blok?.title" class="section-title">
            <StoryblokRichText :doc="blok.title" />
          </h2>
          <div v-if="blok?.description" class="section-description">
            <StoryblokRichText :doc="blok.description" />
          </div>
          <div v-if="blok?.buttons?.length > 0" class="section-buttons">
            <StoryblokComponent v-for="button in blok.buttons" :key="button._uid" :blok="button" />
          </div>
        </div>
        <div v-if="blok.list" class="section-list" :data-columns="blok.columns || 1">
          <StoryblokRichText :doc="blok.list" />
        </div>
      </div>
      <div v-if="blok?.logos?.length > 0" class="row section-logos-row">
        <div class="section-logos" :style="[marqueeSpeed(blok.logos.length * 3)]">
          <img v-for="logo in blok.logos" :key="logo._uid" :src="optimizeImage(logo?.filename)" alt="Section Feature Image" loading="lazy" :blok="logo" :width="getImageDimensions(logo?.filename).width" :height="getImageDimensions(logo?.filename).height" />
          <img v-for="logo in blok.logos" :key="logo._uid" class="logo-clone" :src="optimizeImage(logo?.filename)" alt="Section Feature Image" loading="lazy" :blok="logo" :width="getImageDimensions(logo?.filename).width" :height="getImageDimensions(logo?.filename).height" />
          <img v-for="logo in blok.logos" :key="logo._uid" class="logo-clone" :src="optimizeImage(logo?.filename)" alt="Section Feature Image" loading="lazy" :blok="logo" :width="getImageDimensions(logo?.filename).width" :height="getImageDimensions(logo?.filename).height" />
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
  const props = defineProps({ blok: Object });

  const styleBackground = computed(() => {
    if (props.blok.background?.value) {
      if (props.blok.background?.value === "#E9E1F7") {
        return { background: "linear-gradient(30deg, rgba(233, 225, 247, 0.78) -10.52%, rgba(247, 248, 254, 0.68) 81.92%)" };
      }
      return { backgroundColor: props.blok.background?.value };
    }

    return { backgroundColor: "#fff" };
  });

  const marqueeSpeed = (length) => {
    const baseSpeed = 3;
    const duration = length * baseSpeed;
    return {
      "--duration": `${duration}s`,
    };
  };
</script>
<style src="~/assets/scss/section/feature-title-list.scss" lang="scss"></style>
